import { Box, Text } from '@chakra-ui/react';

const Footer = () => {
  return (
    <Box as="footer" bottom="0%" color="black" width="100%" fontWeight="bold" borderTop="1px solid" borderTopColor="gray.200" bg="white" p={2} textAlign="center" mt="auto">
      <Text fontSize="sm">&copy; {new Date().getFullYear()} e-Zen Configurator. Tutti i diritti riservati.</Text>
    </Box>
  );
};

export default Footer;